import { base, baseSepolia, anvil } from 'viem/chains';
export const usdc = {
    [base.id]: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
    [baseSepolia.id]: '0x036CbD53842c5426634e7929541eC2318f3dCF7e',
    [anvil.id]: '0x036CbD53842c5426634e7929541eC2318f3dCF7e', // we don't have a usdc contract on anvil, this is placeholder
};
export function getUSDCAddress(chain) {
    if (!chain) {
        throw new Error('Chain is required');
    }
    if (chain.id === base.id) {
        return usdc[base.id];
    }
    if (chain.id === baseSepolia.id) {
        return usdc[baseSepolia.id];
    }
    if (chain.id === anvil.id) {
        return usdc[anvil.id];
    }
    throw new Error('Chain not supported');
}
